// extracted by mini-css-extract-plugin
module.exports = {"review":"_02712f2b3b--review--gUEHP","review--link":"_02712f2b3b--review--link--JH8uY","review--link--rating":"_02712f2b3b--review--link--rating--etc1f"};